/**
 * 프로덕션 빌드가 아닐 때만 콘솔 디버그 출력 (CRA: NODE_ENV)
 * 페이지·기능별로 tag 문자열을 구분해 공통 사용
 */

export type DevDebugDataUrlMeta = {
  kind: 'empty' | 'non_data' | 'ok'
  mime?: string
  charLen: number
  payloadLen: number
}

function isEnabled(): boolean {
  return process.env.NODE_ENV !== 'production'
}

function log(tag: string, payload: Record<string, unknown>): void {
  if (!isEnabled()) {
    return
  }
  console.log(tag, payload)
}

/** data URL 본문은 넣지 않고 길이·MIME만 요약 (로그 필드용) */
function dataUrlMeta(dataUrl: string | undefined | null): DevDebugDataUrlMeta {
  if (dataUrl == null || dataUrl.length === 0) {
    return { kind: 'empty', charLen: 0, payloadLen: 0 }
  }
  if (!dataUrl.startsWith('data:')) {
    return { kind: 'non_data', charLen: dataUrl.length, payloadLen: 0 }
  }
  const semi = dataUrl.indexOf(';')
  const mime = semi > 4 ? dataUrl.slice(5, semi) : 'unknown'
  const comma = dataUrl.indexOf(',')
  const payloadLen = comma >= 0 ? dataUrl.slice(comma + 1).length : 0
  return { kind: 'ok', mime, charLen: dataUrl.length, payloadLen }
}

export const devDebug = {
  isEnabled,
  log,
  dataUrlMeta,
}
